import { Logo } from '../Logo/Logo';
import s from './Header.scss';
import { Navigation } from './Navigation/Navigation';
import { Translator } from '../../modules/translate';
import { HeaderStructure } from '../../data/types';
import { Config } from '../../modules/config';

interface HeaderProps {
  t: Translator;
  structure: HeaderStructure;
  config: Config;
}

const Header = ({ t, structure: { nav }, config }: HeaderProps) => {
  return `
    <header class="${s.container}" id="EDITOR_X_HEADER">
      <div class="${s.header}">
        ${Logo({ dataHook: 'editorx-header-logo-link', t, language: config.getContentLanguage() })}
        ${Navigation({ navigation: nav, t })}
      </div>
    </header>
  `;
};

export default Header;
